
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ErrorState = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={theme.spacing(50)}
      sx={{
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
      }}
    >
      <Typography
        color="error"
        variant="body1"
        textAlign="center"
        sx={{
          fontWeight: theme.typography.fontWeightMedium,
        }}
      >
        {t('hotelContent.nimbuxHotels.errors.loadingError')}
      </Typography>
    </Box>
  );
};
